import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, TextField, Checkbox } from 'emerald-ui';

class SignUpFormRegistrationInfo extends Component {
  handleChange = (key) => (event) => {
    const value = event.target.value;
    this.props.handleFieldChange({ [key]: value });
  };

  handleIsHouseChange = (event) => {
    const checked = event.target.checked;
    this.props.handleFieldChange({ isHouse: checked });
  };

  render() {
    const { registrationPhone = {}, courseRegistrationWebsite = {}, companyWebsite = {}, isHouse } = this.props;
    return (
      <Row>
        <Col xs={12} md={5}>
          <div className="sign-up-form-description">
            <p>Registration information</p>
            <p>
              Enter the phone number and course registration website addresses you would like CE Broker to provide
              licensees wishing to enroll in your continuing education programs
            </p>
          </div>
        </Col>
        <Col xs={12} md={7}>
          <div className="sign-up-fields-section">
            <TextField
              id="registrationPhone"
              shape="classic"
              placeholder="(180)999-8888"
              maxLength="14"
              label="Registration phone"
              onChange={this.handleChange('registrationPhone')}
              value={registrationPhone.value || ''}
              error={registrationPhone.displayErrors ? registrationPhone.errorMsg : ''}
            />
          </div>
          <div className="sign-up-fields-section">
            <TextField
              id="courseRegistrationWebsite"
              shape="classic"
              placeholder="www.yourwebsite.com"
              label="Course registration website"
              onChange={this.handleChange('courseRegistrationWebsite')}
              value={courseRegistrationWebsite.value || ''}
              error={courseRegistrationWebsite.displayErrors ? courseRegistrationWebsite.errorMsg : ''}
            />
          </div>
          <div className="sign-up-fields-section">
            <TextField
              id="companyWebsite"
              shape="classic"
              placeholder="www.yourwebsite.com"
              label="Company website"
              onChange={this.handleChange('companyWebsite')}
              value={companyWebsite.value || ''}
              error={companyWebsite.displayErrors ? companyWebsite.errorMsg : ''}
            />
          </div>
          <div className="sign-up-fields-section">
            <Checkbox
              id="isHouse"
              label="Default my courses to be visible in the public course search (this can be changed later or enabled on a per course basis if you choose to do so)"
              defaultChecked={isHouse}
              onChange={this.handleIsHouseChange}
            />
          </div>
        </Col>
      </Row>
    );
  }
}

SignUpFormRegistrationInfo.propTypes = {
  handleFieldChange: PropTypes.func,
  registrationPhone: PropTypes.object,
  courseRegistrationWebsite: PropTypes.object,
  companyWebsite: PropTypes.object,
  isHouse: PropTypes.bool,
};

SignUpFormRegistrationInfo.defaultProps = {
  handleFieldChange: () => {},
};

export default SignUpFormRegistrationInfo;



// WEBPACK FOOTER //
// ./src/components/SignUpFormRegistrationInfo/SignUpFormRegistrationInfo.js